import React from 'react';
import _ from 'lodash';
import { propTypes, withFormsy } from 'formsy-react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel } from '@material-ui/core';

class CheckboxGroupInput extends React.Component {
  constructor(props) {
    super(props);

    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const {value, checked} = event.target;
    const values = this.props.value || [];
    const newValues = checked ? _.concat(values, value) : _.pull(values, value);
    this.props.setValue(newValues);
    this.forceUpdate(); // TODO: Check why this is needed
  }

  render() {
    const { value, label, options, hint, errorMessage, isPristine } = this.props;
    const error = !isPristine && errorMessage != null;

    return (
      <React.Fragment>
        <FormControl component="fieldset" error={error}>
          <FormLabel>
            {label}
          </FormLabel>
          <FormGroup>
            {options.map((option, i) => (
              <FormControlLabel
                key={i} disabled={option.disabled}
                control={<Checkbox value={option.value} onChange={this.changeValue} checked={_.includes(value, option.value)}/>}
                label={option.label}
              />
            ))}
          </FormGroup>
          {error &&
            <FormHelperText error>{errorMessage}</FormHelperText>
          }
          {hint &&
            <FormHelperText>{hint}</FormHelperText>
          }
        </FormControl>
      </React.Fragment>
    );
  }
}

CheckboxGroupInput.propTypes = {
  ...propTypes
};

export default withFormsy(CheckboxGroupInput);
